// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

let language = "ES";
let translations = {};

import $ from "jquery";

import toastr from "toastr";

import groupImportTemplate from './app/angularjs/common/group_import/group_import.html';
import peopleImportTemplate from './app/angularjs/common/people_import/people_import.html';
import eventsAnnexesTemplate from './app/angularjs/events/annexes/events_annexes.html';
import documentsEditTemplate from './app/angularjs/events/documents/documents-edit.html';
import historicMailsFiltersTemplate from './app/angularjs/events/historic_mails/historic_mails_filters.html';
import spacesEditTemplate from './app/angularjs/events/spaces/spaces-edit.html';
import foldersListTemplate from './app/angularjs/folders/folders-list.html';
import groupsEditTemplate from './app/angularjs/groups/groups-edit.html';
import locationsReservationsEditTemplate from './app/angularjs/locations_reservations/locations_reservations-edit.html';
import materialsEditTemplate from './app/angularjs/materials/materials-edit.html';
import addressTemplate from './app/angularjs/persons/partials/address.html';
import contactTemplate from './app/angularjs/persons/partials/contact.html';
import groupTemplate from './app/angularjs/persons/partials/group.html';
import mailTemplate from './app/angularjs/persons/partials/mail.html';
import politicalAffiliationTemplate from './app/angularjs/persons/partials/political-affiliation.html';
import personsEditTemplate from './app/angularjs/persons/persons-edit.html';
import restaurantsEditTemplate from './app/angularjs/restaurants/restaurants-edit.html';
import staffEditTemplate from './app/angularjs/staff/staff-edit.html';
import calendarTemplate from './app/angularjs/common/calendar/calendar.html';
import groupListPrintedTemplate from './app/angularjs/groups/group-list-printed.html';
import loadingTemplate from './app/angularjs/common/loading/loading.html';
import navigationTemplate from './app/angularjs/common/navigation/navigation.html';
import footerTemplate from './app/angularjs/common/footer/footer.html';
import topnavbarTemplate from './app/angularjs/common/topnavbar/topnavbar.html';
import spacesEditTemplate from './app/angularjs/events/spaces/spaces-edit.html';

export const app = angular.module("app", [

    'ui.router',                    // Routing
    'ui.bootstrap',                 // Bootstrap
    'ui.tree',                      // Nestable list
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.exporter',
    'ui.grid.pagination',
    'ui.grid.treeView',
    'ui.grid.autoResize',
    'ui.grid.edit',
    'ui.grid.cellNav',
    'ui.grid.expandable',
    'ui.calendar',
    'ui.validate',
    'ui.date',
    'ui.sortable',
    'ui.slider',
    'ui.ace',
    'gantt', 'gantt.table', 'gantt.tree', 'gantt.tooltips', 'gantt.progress', 'gantt.drawtask', 'gantt.movable',
    'ui-iconpicker',
    'ngAnimate',
    'inspinia',
    'restangular',
    'log.ex.uo',
    'angular.filter',
    'topnavbar',
    'ibox_tools',
    'events',
    'dashboard',
    'dashboard_space',
    'navigation',
    'calendar',
    'users',
    'roles',
    'login',
    'auth',
    'update',
    'companies',
    'documents_reports',
    'documents_types',
    'countries',
    'menus',
    'languages',
    'groups',
    'persons',
    'political_affiliations',
    'staff',
    'staff_positions',
    'gifts',
    'persons_gifts',
    'materials',
    'files_types',
    'files_types_whitelist',
    'materials_types',
    'events_users_profiles',
    'indicators_types',
    'persons_information_groups',
    'informations',
    'tasks_reports',
    'restaurants',
    'locations_reservations',
    'locations',
    'mail_accounts',
    'persons_reports',
    'gifts_reports',
    'resume_reports',
    'budget_groups',
    'inscriptions_forms',
    'identifiers',
    'contact_types',
    'persons_treatments',
    'import_documents',
    'razor_views',
    'notifications',
    'mailings',
    'breadcrumb',
    'modal',
    'ui.select',
    'ngSanitize',
    'forbidden',
    'warehouses',
    'providers',
    'pascalprecht.translate',
    'colorpicker.module',
    'flow',
    'eventHosts',
    'authenticationServices',
    'cmsCategories',
    'cmsArticles',
    'mailings_types',
    'passbooks',
    'tags',
    'users_groups',
    'institutions',
    'group_import',
    'authentication_processes',
    'angularjs.chips',
    'events_programs_mails',

   // 'documents',
    'spaces',
    'ui.tinymce',
    'ngFileUpload',
    'angular-clipboard',
    'uiSwitch',
    'matchMedia',
    'events_types',
    'reports',
    'notifications_by_person',
    'rgpd',
    'templates',
    'datasets',
    'folders',
    'tasks_status',
    'tasks_types',
    'correspondence',
    'correspondences_types',
    'tasks',
    'annexes',
    'accesses',
    'audits',
    'push_notifications_types',
    'push_notifications',
    'people_import',
    'common-routes',
    //
      
]).config(['$stateProvider', '$httpProvider', '$urlRouterProvider', '$translateProvider', '$animateProvider', '$compileProvider', '$uibModalProvider', 'RestangularProvider', 'logServiceProvider', 'logExProvider', '$locationProvider', function ($stateProvider, $httpProvider, $urlRouterProvider, $translateProvider, $animateProvider, $compileProvider, $uibModalProvider, RestangularProvider, logServiceProvider, logExProvider, $locationProvider) {

$locationProvider.hashPrefix('');
//$locationProvider.html5Mode(true);

//configuramos ruta base
RestangularProvider.setBaseUrl((window as any).CONFIG.api_url);
//mejora prestaciones en producción.
$compileProvider.debugInfoEnabled(false);

let debug = window.location.hostname.indexOf("localhost") > -1 || window.location.hostname.indexOf("test.diaple") > -1 
    || window.location.hostname.indexOf("pre.stela.pro") > -1;
logExProvider.enableLogging(true, debug);
logExProvider.useTemplates(true);
logExProvider.overrideLogPrefix(function (className) {
    let  $injector = angular.injector([ 'ng' ]);
    let  $filter = $injector.get( '$filter' );
    let  separator = " >> ";
    let  format = "dd/MM/yyyy hh:mm:ss";
    let  now = $filter('date')(new Date(), format);
    return "" + now + (!angular.isString(className) ? "" : "::" + className) + separator;
});
/*logExProvider.overrideLogMethodColors({
        log: 'color: white;', 
        info: 'color: blue; background-color: white;',
        debug: 'color: green; background-color: white;',
    });*/
if(!debug) {
    logExProvider.restrictLogMethods(['error', 'warn']);
}

//configuramos que no se cierre el dialogo con click
$uibModalProvider.options.backdrop = 'static';

$httpProvider.defaults.headers.common["language_code"] = language;
// $translateProvider.translations(language, translations);
$translateProvider.preferredLanguage(language);
$translateProvider.fallbackLanguage("ES");
$translateProvider.useUrlLoader((window as any).CONFIG.api_url + '/lang');
$translateProvider.useSanitizeValueStrategy('escape');

//interceptor para controlar errores en peticiones
$httpProvider.interceptors.push('httpInterceptorService');

//desactivamos animacion de menu de ui-grid para que funcione en firefox correctamente la ocultacion
$animateProvider.classNameFilter(/^((?!(ui-grid-menu)).)*$/);

$urlRouterProvider.otherwise("/dashboard/list");
$urlRouterProvider.when('', '/dashboard/list');
   toastr.options = {
        "closeButton": true,
        "debug": false,
        "progressBar": true,
        "preventDuplicates": false,
        "positionClass": "toast-top-right",
        "onclick": null,
        "showDuration": 400,
        "hideDuration": 1000,
        "timeOut": 2000,
        "extendedTimeOut": 1000,
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

}])
.run(['uiGridSelectionService', '$rootScope', '$http', '$state', 'i18nService', '$translate', 'UpdateService', '$window', '$injector', 'LoginService', 'Restangular', '$q', '$timeout', 'logService', '$document', '$templateCache', function (uiGridSelectionService, $rootScope, $http, $state, i18nService, $translate, UpdateService, $window, $injector, LoginService, Restangular, $q, $timeout, logService, $document, $templateCache) {
    Restangular.addResponseInterceptor(function (data, operation, what, url, response, deferred) {
        if (operation === "getList" && !angular.isUndefined(response.data.rows)) {
            let responseData = response.data.rows;
            responseData.totalRows = response.data.totalRows;
            return responseData;
        } else
            return response.data;
    });

    $templateCache.put('address.html', addressTemplate);
    $templateCache.put('calendar.html', calendarTemplate);
    $templateCache.put('contact.html', contactTemplate);
    $templateCache.put('documents-edit.html', documentsEditTemplate);
    $templateCache.put('events_annexes.html', eventsAnnexesTemplate);
    $templateCache.put('folders-list.html', foldersListTemplate);
    $templateCache.put('footer.html', footerTemplate);
    $templateCache.put('group-list-printed.html', groupListPrintedTemplate);
    $templateCache.put('group.html', groupTemplate);
    $templateCache.put('group_import.html', groupImportTemplate);
    $templateCache.put('groups-edit.html', groupsEditTemplate);
    $templateCache.put('historic_mails_filters.html', historicMailsFiltersTemplate);
    $templateCache.put('loading.html', loadingTemplate);
    $templateCache.put('locations_reservations-edit.html', locationsReservationsEditTemplate);
    $templateCache.put('mail.html', mailTemplate);
    $templateCache.put('materials-edit.html', materialsEditTemplate);
    $templateCache.put('navigation.html', navigationTemplate);
    $templateCache.put('people_import.html', peopleImportTemplate);
    $templateCache.put('persons-edit.html', personsEditTemplate);
    $templateCache.put('political-affiliation.html', politicalAffiliationTemplate);
    $templateCache.put('restaurants-edit.html', restaurantsEditTemplate);
    $templateCache.put('spaces-edit.html', spacesEditTemplate);
    $templateCache.put('staff-edit.html', staffEditTemplate);
    $templateCache.put('topnavbar.html', topnavbarTemplate);

    let inflightAuthRequest = null;

    function refreshAccesstoken() {
        let deferred = $q.defer();

        if(!inflightAuthRequest) {
            delete $http.defaults.headers.common["Authorization"];
            inflightAuthRequest = $http.post((window as any).CONFIG.api_url + "/Auth/Refresh",
                { AccessToken: localStorage.getItem("accessToken") })
        }

        inflightAuthRequest.then(function (response) {
            inflightAuthRequest = null;
            let LoginService = $injector.get('LoginService');

            LoginService.saveTokenInfo(response.data);
            $http.defaults.headers.common["Authorization"] = "Bearer " + response.data.token.accessToken;
            
            deferred.resolve(response.data.token.accessToken);
        });

        return deferred.promise;        
    }

    Restangular.addErrorInterceptor(function (response, deferred, responseHandler) {
        // Petición cancelada por nosotros al cambiar de ruta (AB#2897).
        // status=-1 es ambiguo: abort, timeout o pérdida de red. Si fue una
        // cancelación intencionada, no debe disparar redirect al login.
        if (response.status === -1 && response.config && response.config.__cancelable) {
            return false; // error handled (silenciar)
        }

        logService.error(response);
        if (//response.status === 400 ||
            response.status === -1 || response.status === 440) {

            location.replace("#/auth/init");
            return true; // error not handled
        }
        // IDX10503
        if (response.status === 401 && typeof (response.data) == "string" && response.data.includes("IDX")) {

            //enviamos a login, salvo que ya este en login
            if (location.pathname !== "/" && location.hash !== "#/auth/init") {
                location.replace("#/auth/init");
            }

            return true; // error handled

        }
        if (response.status === 403 || response.status === 401) {
            location.replace("#/forbidden/list");
            return false; // error handled
        }

        return true; // error not handled
    });
    
    // que solo se marque todos si estan todas las filas incluidas las no visibles marcadas
    uiGridSelectionService.toggleRowSelection = function (grid, row, evt, multiSelect, noUnselect) {

        let  selected = row.isSelected;

        if (row.enableSelection === false && !selected) {
            return;
        }

        let  selectedRows;

        if (!multiSelect && !selected) {
            uiGridSelectionService.clearSelectedRows(grid, evt);
        } else if (!multiSelect && selected) {
            selectedRows = uiGridSelectionService.getSelectedRows(grid);
            if (selectedRows.length > 1) {
                selected = false; // Enable reselect of the row
                uiGridSelectionService.clearSelectedRows(grid, evt);
            }
        }

        if (selected && noUnselect) {
            // don't deselect the row
        } else {

            row.setSelected(!selected);

            if (row.isSelected === true) {
                grid.selection.lastSelectedRow = row;
            }

            selectedRows = uiGridSelectionService.getSelectedRows(grid);
            grid.selection.selectAll = grid.options.totalItems === selectedRows.length;

            grid.api.selection.raise.rowSelectionChanged(row, evt);

        }
    };

    $rootScope.language = language;

    //comprobamos si la licencia de demo a expirado

    $rootScope.licenseExpired = false;

    /*let  limitDate = new Date(2017, 2, 20);
    if((new Date()).getTime()>limitDate.getTime()){
        $rootScope.licenseExpired = true;
    }*/

    $rootScope.loginProcess = false;

    //cargamos tema por defecto
    let  theme = localStorage.getItem("theme");
    $rootScope.theme = "skin-3";
    if (theme != null) $rootScope.theme = theme;

    $rootScope.$on('$stateChangeStart',
         function (event, toState, toParams, fromState, fromParams) {
             $window.scrollTo(0, 0);
             if (!LoginService.isLoggedIn() && toState.url !== "/login" && toState.url.substring(0, 6) !== "/auth/") {
                 // Si no está logueado e intenta ir a cualquier estado
                 event.preventDefault();
                 $state.go("authinit");
             } else if (toState.url === "/login") {
                 //borramos cabecera si existe
                 try {
                     delete $http.defaults.headers.common.Authorization;
                 } catch (e) {

                 }

                 // Va a login directamente
                 //if (!LoginService.isLoggedIn()) {
                     $rootScope.islogged = false;
                     LoginService.unset("accessToken");
                     LoginService.unset("rolesPermissions");
                     LoginService.unset("userName");
                     LoginService.unset("userId");
                 //} else {
                 //    $state.go("dashboard.list");
                 //}
             } else if(toState.url.substring(0, 9) !== "/process/" && toState.url.substring(0, 6) !== "/auth/") {
                 //Cualquier estado y logueado
                 if (angular.isDefined(toState.requiredPermission)) {
                     if (toState.requiredPermission.length > 0) {
                         let forbidden = true;
                         for (let  i = 0, len = toState.requiredPermission.length; i < len; i++) {
                             if (LoginService.permissionExist(toState.requiredPermission[i])) {
                                 forbidden = false;
                                 break;
                             }
                         }
                         if (forbidden) {
                             event.preventDefault();
                             location.replace("#/forbidden/list");
                         }
                     }
                 }
                 $rootScope.islogged = true;
             } else {
                 //borramos cabecera si existe
                 try {
                     delete $http.defaults.headers.common.Authorization;
                 } catch (e) {

                 }

                 // Va a login directamente
                 //if (!LoginService.isLoggedIn()) {
                 $rootScope.islogged = false;
                 LoginService.unset("accessToken");
                 LoginService.unset("rolesPermissions");
                 LoginService.unset("userName");
                 LoginService.unset("userId");

             }
         });

    //escuchamos camibos de peticiones para mostrar o no el cargador
    $rootScope.$watch(
        function () {
            return $http.pendingRequests.length;
        }, function () {
            if ($http.pendingRequests.length > 0
                    && $http.pendingRequests[0].url.indexOf('EventsGuests/GetEventGuest') < 0
                    && $http.pendingRequests[0].url.indexOf('EventsTaks/GetEventTasks') < 0
                    && $http.pendingRequests[0].url.indexOf('EventsStaff/GetEventStaff') < 0
                    && $http.pendingRequests[0].url.indexOf('EventsMaterials/GetEventMaterial') < 0
                    && $http.pendingRequests[0].url.indexOf('Events/getActualEventCounts') < 0
                    && $http.pendingRequests[0].url.indexOf('Events/getActualEventInfo') < 0
                    && $http.pendingRequests[0].url.indexOf('Events/CustomActualTotemInfo') < 0
                    && $http.pendingRequests[0].url.indexOf('update/check') < 0
                    && $http.pendingRequests[0].url.indexOf('/keepalive') < 0
                    && $http.pendingRequests[0].url.indexOf('inscriptions/GetPendingInscriptions') < 0) {
                $rootScope.showLoading = $http.pendingRequests.length > 0;
            } else {
                $rootScope.showLoading = false;
            }
        }
    );

    //configurar idioma de grid
    i18nService.setCurrentLang(language.toLowerCase());

    //configuramos comprobador de nuevas versiones

    //UpdateService.autoCheck(30);
    UpdateService.onUpdateAvailable = function (version) {
        $rootScope.version = version;
    };
    UpdateService.getInstalledVersion().then(function (response) {
        $rootScope.actualVersion = response.data;
    }, function (error) {
        logService.error(error);
    });

    // Set current year for copyright
    $rootScope.currentYear = (new Date()).getFullYear();

    logService.debug('starting run');

    // Timeout timer value
    $rootScope.TimeOutTimerValue = 2 * 60 * 1000;

    let bodyElement = angular.element($document);

    angular.forEach(['keydown', 'keyup', 'click', 'mousemove', 'DOMMouseScroll', 'mousewheel', 'mousedown', 'touchstart', 'touchmove', 'scroll', 'focus'],
        function(EventName) {
            bodyElement.bind(EventName, function (e) { LoginService.resetInactivityTimeoutDate(); });
    });
}])

.filter('startFrom', [function () {
    return function (input, start) {
        if (typeof input == "undefined") return [];
        start = +start; //parse to int
        return input.slice(start);
    }
    }])

.directive('clickOutside', ['$document', function ($document) {
    return {
        link: function postLink(scope, element, attrs) {
            let  onClick = function (event) {
                let  isChild = $(element).has(event.target).length > 0;
                let  isSelf = element[0] == event.target;
                let  isInside = isChild || isSelf;
                if (!isInside) {
                    scope.$apply(attrs.clickAnywhereButHere)
                }
            }
            scope.$watch(attrs.isActive, function (newValue, oldValue) {
                if (newValue !== oldValue && newValue == true) {
                    $document.bind('click', onClick);
                }
                else if (newValue !== oldValue && newValue == false) {
                    $document.unbind('click', onClick);
                }
            });
        }
    };
}]);


$(function ($) {
    if (language == "") {
        if (angular.isDefined(navigator.languages) && navigator.languages.length > 0) {
            let  parts = navigator.languages[0].toUpperCase().split("-");
            language = parts[0];
        }
    }
    if (language == "" || language == null) language = "ES";

    $.datepicker.regional['es'] = {
        closeText: 'Cerrar',
        prevText: '<Ant',
        nextText: 'Sig>',
        currentText: 'Hoy',
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Juv', 'Vie', 'Sáb'],
        dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
        weekHeader: 'Sm',
        dateFormat: 'dd/mm/yy',
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ''
    };

    if (language == "ES") $.datepicker.setDefaults($.datepicker.regional['es']);

    angular.module('ui.grid').config(['$provide', function ($provide) {
        $provide.decorator('i18nService', ['$delegate', function ($delegate) {
            $delegate.add('ca', {
                aggregate: {
                    label: 'Article'
                },
                groupPanel: {
                    description: 'Arrossegueu una capçalera de columna aquí i deixeu-lo anar per agrupar per aquesta columna.'
                },
                search: {
                    placeholder: 'Cercar...',
                    showingItems: 'Articles llistats:',
                    selectedItems: 'Articles seleccionats:',
                    totalItems: 'Articles totals:',
                    size: 'Mida de Pàgina:',
                    first: 'primera Pàgina',
                    next: 'Pàgina Següent',
                    previous: 'Pàgina Anterior',
                    last: 'Darrera Pàgina'
                },
                menu: {
                    text: 'Triar columnes:'
                },
                sort: {
                    ascending: 'Ordre Ascendent',
                    descending: 'Ordre Descendent',
                    remove: 'Sense Ordenar'
                },
                column: {
                    hide: 'Amaga la columna'
                },
                aggregation: {
                    count: 'filas totales: ',
                    sum: 'total: ',
                    avg: 'media: ',
                    min: 'min: ',
                    max: 'max: '
                },
                pinning: {
                    pinLeft: 'Fijar a la Izquierda',
                    pinRight: 'Fijar a la Derecha',
                    unpin: 'Quitar Fijación'
                },
                gridMenu: {
                    columns: 'Columnas:',
                    importerTitle: 'Importa fitxer',
                    exporterAllAsCsv: 'Exporta tot com csv',
                    exporterVisibleAsCsv: 'Exportar vista com csv ',
                    exporterSelectedAsCsv: 'Exportar selecció com csv',
                    exporterAllAsPdf: 'Exporta tot com PDF',
                    exporterVisibleAsPdf: 'Exportar vista como pdf',
                    exporterSelectedAsPdf: 'Exportar selecció com pdf',
                    clearAllFilters: 'Netejar tots els filtres'
                },
                importer: {
                    noHeaders: 'No va ser possible derilet  els noms de les columnes, té encapçalats l\'arxiu?',
                    noObjects: 'No va ser possible obtenir registres, conté dades l\'arxiu, a part de les capçaleres?',
                    invalidCsv: 'No va ser possible processar l\'arxiu, ¿és un CSV vàlid ?',
                    invalidJson: 'No va ser possible processar l\'arxiu, ¿és un JSON vàlid ?',
                    jsonNotArray: 'L\'arxiu json importat ha de contenir una matriu, avortant.'
                },
                pagination: {
                    sizes: 'registres per pàgina',
                    totalItems: 'registres',
                    of: 'de'
                },
                grouping: {
                    group: 'Agrupar',
                    ungroup: 'Desagrupa',
                    aggregate_count: 'Agr: Cont',
                    aggregate_sum: 'Agr: Sum',
                    aggregate_max: 'Agr: Máx',
                    aggregate_min: 'Agr: Min',
                    aggregate_avg: 'Agr: Prom',
                    aggregate_remove: 'Agr: Quitar'
                }
            });
            return $delegate;
        }]);
    }]);

});
